import type { PayloadAction } from '@reduxjs/toolkit';
import { deleteIssue as deleteIssueState } from '@ui/features/quote-builder/state/utilities/issue-managers';
import type { IssueDeleteOptions } from '@ui/features/quote-builder/types/state/issues';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';

/**
 * Action for upserting issues in the QuoteBuilderState. Useful for adding
 * issues from thunks (that must dispatch actions and cannot edit a
 * `WritableDraft` directly using the `upsertIssue` utility function).
 */
export function deleteIssue(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<{
    issueId: string;
    options?: IssueDeleteOptions;
  }>,
) {
  deleteIssueState(state, action.payload.issueId, action.payload.options);
}
